<template>
    <div class="ranking-list">
        <PageHeader></PageHeader>
        <van-tabs v-model="value">
            <!-- 男频 -->
            <van-tab title="男频">
                <el-tabs tab-position="left" v-model="subvalue">
                    <el-tab-pane label="最热榜">
                        <ul class="rank-book">
                            <RankingBookCard v-for="(item, index) in maleHottestList" :key="index" :item="item" :num="index"></RankingBookCard>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="畅销榜">
                        <ul class="rank-book">
                            <RankingBookCard v-for="(item, index) in malePraiseList" :key="index" :item="item" :num="index"></RankingBookCard>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="热搜榜">
                        <ul class="rank-book">
                            <RankingBookCard v-for="(item, index) in maleMostSearched" :key="index" :item="item" :num="index"></RankingBookCard>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="潜力榜">
                        <ul class="rank-book">
                            <RankingBookCard v-for="(item, index) in malePotentialList" :key="index" :item="item" :num="index"></RankingBookCard>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="留存榜">
                        <ul class="rank-book">
                            <RankingBookCard v-for="(item, index) in maleKeepList" :key="index" :item="item" :num="index"></RankingBookCard>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="完结榜">
                        <ul class="rank-book">
                            <RankingBookCard v-for="(item, index) in maleEndList" :key="index" :item="item" :num="index"></RankingBookCard>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="VIP榜">
                        <ul class="rank-book">
                            <RankingBookCard v-for="(item, index) in maleViptList" :key="index" :item="item" :num="index"></RankingBookCard>
                        </ul>
                    </el-tab-pane>
                </el-tabs>
            </van-tab>
            <!-- 女频 -->
            <van-tab title="女频">
                <el-tabs tab-position="left" v-model="subvalue">
                    <el-tab-pane label="最热榜">
                        <ul class="rank-book">
                            <RankingBookCard v-for="(item, index) in femaleHottestList" :key="index" :item="item" :num="index"></RankingBookCard>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="畅销榜">
                        <ul class="rank-book">
                            <RankingBookCard v-for="(item, index) in femalePraiseList" :key="index" :item="item" :num="index"></RankingBookCard>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="热搜榜">
                        <ul class="rank-book">
                            <RankingBookCard v-for="(item, index) in femaleMostSearched" :key="index" :item="item" :num="index"></RankingBookCard>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="潜力榜">
                        <ul class="rank-book">
                            <RankingBookCard v-for="(item, index) in femalePotentialList" :key="index" :item="item" :num="index"></RankingBookCard>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="留存榜">
                        <ul class="rank-book">
                            <RankingBookCard v-for="(item, index) in femaleKeepList" :key="index" :item="item" :num="index"></RankingBookCard>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="完结榜">
                        <ul class="rank-book">
                            <RankingBookCard v-for="(item, index) in femaleEndList" :key="index" :item="item" :num="index"></RankingBookCard>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="VIP榜">
                        <ul class="rank-book">
                            <RankingBookCard v-for="(item, index) in femaleViptList" :key="index" :item="item" :num="index"></RankingBookCard>
                        </ul>
                    </el-tab-pane>
                </el-tabs>
            </van-tab>
            <!-- 出版 -->
            <van-tab title="出版">
                <el-tabs tab-position="left" v-model="subvalue">
                    <el-tab-pane label="热搜榜">
                        <ul class="rank-book">
                            <RankingBookCard v-for="(item, index) in epubHottestList" :key="index" :item="item" :num="index"></RankingBookCard>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="畅销榜">
                        <ul class="rank-book">
                            <RankingBookCard v-for="(item, index) in epubPraiseList" :key="index" :item="item" :num="index"></RankingBookCard>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="VIP榜">
                        <ul class="rank-book">
                            <RankingBookCard v-for="(item, index) in epubViptList" :key="index" :item="item" :num="index"></RankingBookCard>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="新书榜">
                        <ul class="rank-book">
                            <RankingBookCard v-for="(item, index) in epubNewBookList" :key="index" :item="item" :num="index"></RankingBookCard>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="收藏榜">
                        <ul class="rank-book">
                            <RankingBookCard v-for="(item, index) in epubCollectList" :key="index" :item="item" :num="index"></RankingBookCard>
                        </ul>
                    </el-tab-pane>
                </el-tabs>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import RankingBookCard from "@/components/RankingBookCard.vue";

export default {
    data() {
        return {
            value: 0,
            subvalue: 0,
            maleRankList: null,
            femaleRankList: null,
            epubRankList: null,

            maleHottestList: null,
            malePraiseList: null,
            maleMostSearched: null,
            malePotentialList: null,
            maleKeepList: null,
            maleEndList: null,
            maleViptList: null,

            femaleHottestList: null,
            femalePraiseList: null,
            femaleMostSearched: null,
            femalePotentialList: null,
            femaleKeepList: null,
            femaleEndList: null,
            femaleViptList: null,

            epubHottestList: null,
            epubPraiseList: null,
            epubViptList: null,
            epubNewBookList: null,
            epubCollectList: null
        };
    },
    components: {
        PageHeader,
        RankingBookCard
    },
    created() {
        // this.getRankCategory();
        this.getRankCategoryDetail("54d42d92321052167dfb75e3", "maleHottestList");
        this.getRankCategoryDetail("5a6844aafc84c2b8efaa6b6e", "malePraiseList");
        this.getRankCategoryDetail("5a6844f8fc84c2b8efaa8bc5", "maleMostSearched");
        this.getRankCategoryDetail("54d42e72d9de23382e6877fb", "malePotentialList");
        this.getRankCategoryDetail("564547c694f1c6a144ec979b", "maleKeepList");
        this.getRankCategoryDetail("564eb878efe5b8e745508fde", "maleEndList");
        this.getRankCategoryDetail("57eb86f0ef9e5a8f20543d7d", "maleViptList");

        this.getRankCategoryDetail("54d43437d47d13ff21cad58b", "femaleHottestList");
        this.getRankCategoryDetail("5a684551fc84c2b8efaab179", "femalePraiseList");
        this.getRankCategoryDetail("5a684515fc84c2b8efaa9875", "femaleMostSearched");
        this.getRankCategoryDetail("54d43709fd6ec9ae04184aa5", "femalePotentialList");
        this.getRankCategoryDetail("5645482405b052fe70aeb1b5", "femaleKeepList");
        this.getRankCategoryDetail("564eb8a9cf77e9b25056162d", "femaleEndList");
        this.getRankCategoryDetail("57eb959df60eb7e21fb3a8b7", "femaleViptList");

        this.getRankCategoryDetail("5a323096fc84c2b8efab2482", "epubHottestList");
        this.getRankCategoryDetail("5a39d435fc84c2b8ef884798", "epubPraiseList");
        this.getRankCategoryDetail("5a683b68fc84c2b8efa68fc2", "epubViptList");
        this.getRankCategoryDetail("5a39d453fc84c2b8ef885812", "epubNewBookList");
        this.getRankCategoryDetail("5a683b8ffc84c2b8efa69fe6", "epubCollectList");
    },
    methods: {
        getRankCategory() {
            this.axios.get("https://novel.kele8.cn/rank-category").then(response => {
                window.console.log(response.data);
                this.maleRankList = response.data.male.slice(0, 7);
                this.femaleRankList = response.data.female.slice(0, 7);
                this.epubRankList = response.data.epub;
            });
        },
        getRankCategoryDetail(rankId, rankList) {
            // let rankList = localStorage.getItem("rankList");
            // window.console.log(rankList);
            // if (localStorage.getItem(rankList)) {
            //     this.rankList = JSON.parse(rankList).data;
            // }else {
            this.axios.get("https://novel.kele8.cn/rank/" + rankId).then(response => {
                this.$toast.loading({ message: "加载中...", forbidClick: true, loadingType: "spinner" });

                window.console.log(response.data.ranking);
                // 男
                if (rankList == "maleHottestList") {
                    ({ books: this.maleHottestList } = response.data.ranking);
                }
                if (rankList == "malePraiseList") {
                    ({ books: this.malePraiseList } = response.data.ranking);
                }
                if (rankList == "maleMostSearched") {
                    ({ books: this.maleMostSearched } = response.data.ranking);
                }
                if (rankList == "malePotentialList") {
                    ({ books: this.malePotentialList } = response.data.ranking);
                }
                if (rankList == "maleKeepList") {
                    ({ books: this.maleKeepList } = response.data.ranking);
                }
                if (rankList == "maleEndList") {
                    ({ books: this.maleEndList } = response.data.ranking);
                }
                if (rankList == "maleViptList: ") {
                    ({ books: this.maleViptList } = response.data.ranking);
                }
                // 女
                if (rankList == "femaleHottestList") {
                    ({ books: this.femaleHottestList } = response.data.ranking);
                }
                if (rankList == "femalePraiseList") {
                    ({ books: this.femalePraiseList } = response.data.ranking);
                }
                if (rankList == "femaleMostSearched") {
                    ({ books: this.femaleMostSearched } = response.data.ranking);
                }
                if (rankList == "femalePotentialList") {
                    ({ books: this.femalePotentialList } = response.data.ranking);
                }
                if (rankList == "femaleKeepList") {
                    ({ books: this.femaleKeepList } = response.data.ranking);
                }
                if (rankList == "femaleEndList") {
                    ({ books: this.femaleEndList } = response.data.ranking);
                }
                if (rankList == "femaleViptList: ") {
                    ({ books: this.femaleViptList } = response.data.ranking);
                }
                // 出版
                if (rankList == "epubHottestList") {
                    ({ books: this.epubHottestList } = response.data.ranking);
                }
                if (rankList == "epubPraiseList") {
                    ({ books: this.epubPraiseList } = response.data.ranking);
                }
                if (rankList == "epubViptList") {
                    ({ books: this.epubViptList } = response.data.ranking);
                }
                if (rankList == "epubNewBookList") {
                    ({ books: this.epubNewBookList } = response.data.ranking);
                }
                if (rankList == "epubCollectList") {
                    ({ books: this.epubCollectList } = response.data.ranking);
                }
            }).finally(this.$toast.clear());
        }
    }
};
</script>

<style>
.el-tabs--left .el-tabs__item.is-left {
    text-align: center;
}
.van-tab {
    font-size: 16px;
}
.el-tabs__item.is-active {
    color: #b83320;
    background: rgb(241, 241, 241);
}
.el-tabs__active-bar {
    color: #b83320;
    background-color: #b83320;
}
ul.rank-book{
    margin-bottom: 50px;
}
</style>
